import React, { useEffect } from 'react'
import { segmentTrack } from '@src/functions/segment'
import classes from '@src/styles/disposal/landing-video.module.css'

export type LandingVideoProps = {
  /** YouTube video id. Defaults to the shared solar explainer. */
  videoId?: string
  /** Section heading rendered above the player. */
  heading?: string
  /** Service slug, used purely for analytics tagging (e.g. 'solar-panel-disposal'). */
  service?: string
}

/**
 * Full-width responsive YouTube embed for the disposal pages, mirroring the
 * `LandingVideo` unit on the React solar landing pages. Uses youtube-nocookie
 * with `loading="lazy"` so it doesn't cost a network round-trip until scrolled
 * into view.
 */
function LandingVideo({
  videoId = 'u53lyuqAF4g',
  heading = '',
  service,
}: LandingVideoProps) {
  useEffect(() => {
    segmentTrack('Landing Page Video Loaded', { service })
  }, [service])

  return (
    <section className={classes.container}>
      <div className={classes.inner}>
        {heading ? <h2 className={classes.heading}>{heading}</h2> : null}
        <div className={classes.frameWrapper}>
          <iframe
            className={classes.frame}
            src={`https://www.youtube-nocookie.com/embed/${videoId}`}
            title="Dimension solar panel recycling"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  )
}

export default LandingVideo
